import Home from '~pages/home';
import Products from '~pages/products';
import Enterprise from '~pages/products/enterprise';
import Community from '~pages/products/community';
import Solutions from '~pages/solutions';
import SecurityOperationsCentres from '~pages/solutions/security-operations-centres';
import ManagedServiceProviders from '~pages/solutions/managed-service-providers';
import LawEnforcement from '~pages/solutions/law-enforcement';
import About from '~pages/about';
import Contact from '~pages/contact';
import TermsOfService from '~pages/legal/terms-of-service';
import PrivacyPolicy from '~pages/legal/privacy-policy';
import ProofOfValueAgreement from '~pages/legal/proof-of-value-agreement';
import ServiceAgreement from '~pages/legal/service-agreement';
import { NotFound } from '@phishtool/ui';
import defaultHydrate from '~server/hydrate/common';
import notFoundHydrate from '~server/hydrate/not-found';
const routes = [
    {
        path: '/',
        exact: true,
        component: Home,
        hydrate: defaultHydrate,
        title: '',
        description: 'PhishTool gives human analysts the power to reverse engineer phishing emails, to better defend against them. Try PhishTool Community for free.',
    },
    {
        path: '/products',
        exact: true,
        component: Products,
        hydrate: defaultHydrate,
        title: 'Products',
        description: '',
    },
    {
        path: '/products/enterprise',
        exact: true,
        component: Enterprise,
        hydrate: defaultHydrate,
        title: 'Enterprise',
        description: 'Defeat phishing campaigns, outsmart adversaries, protect your organisation from phishing emails with PhishTool Enterprise.',
    },
    {
        path: '/products/community',
        exact: true,
        component: Community,
        hydrate: defaultHydrate,
        title: 'Community',
        description: 'Discover how to reverse engineer phishing emails, uncover new indicators, and outsmart phishing campaigns for free with PhishTool Community.',
    },
    {
        path: '/solutions',
        exact: true,
        component: Solutions,
        hydrate: defaultHydrate,
        title: 'Solutions',
        description: '',
    },
    {
        path: '/solutions/security-operations-centres',
        exact: true,
        component: SecurityOperationsCentres,
        hydrate: defaultHydrate,
        title: 'Security Operations Centres',
        description: 'Accelerate your phishing response, harness the value of user reported phishing emails and reduce workload with PhishTool Enterprise for SOCs.',
    },
    {
        path: '/solutions/managed-service-providers',
        exact: true,
        component: ManagedServiceProviders,
        hydrate: defaultHydrate,
        title: 'Managed Service Providers',
        description: 'Provide your customers with a definitive answer to the question of phishing with an advanced phishing incident response capability for MSPs.',
    },
    {
        path: '/solutions/law-enforcement',
        exact: true,
        component: LawEnforcement,
        hydrate: defaultHydrate,
        title: 'Law Enforcement',
        description: 'Cutting-edge email forensics and reverse engineering applied to email-based evidence and cybercrime detection, for law enforcement agencies.',
    },
    {
        path: '/about',
        exact: true,
        component: About,
        hydrate: defaultHydrate,
        title: 'About',
        description: 'PhishTool is on a mission to make email secure and to rid the world of phishing. Find out more about us.',
    },
    {
        path: '/contact',
        exact: true,
        component: Contact,
        hydrate: defaultHydrate,
        title: 'Contact',
        description: 'PhishTool is here to support you - ask us technical questions about phishing emails or make feature requests. We want to hear from you.',
    },
    {
        path: '/terms-of-service',
        exact: true,
        component: TermsOfService,
        hydrate: defaultHydrate,
        title: 'Terms of Service',
        description: '',
    },
    {
        path: '/privacy-policy',
        exact: true,
        component: PrivacyPolicy,
        hydrate: defaultHydrate,
        title: 'Privacy Policy',
        description: '',
    },
    {
        path: '/proof-of-value-agreement',
        exact: true,
        component: ProofOfValueAgreement,
        hydrate: defaultHydrate,
        title: 'Proof of Value Agreement',
        description: '',
    },
    {
        path: '/service-agreement',
        exact: true,
        component: ServiceAgreement,
        hydrate: defaultHydrate,
        title: 'Service Agreement',
        description: '',
    },
    {
        path: '*',
        component: NotFound,
        hydrate: notFoundHydrate,
    },
];
export default routes;
